//////////////////////////////////////////////////////////////////////////
// Member Price and Regular Price Toggle on product page.

function toggleButtons() {
  function setDisplayImportantJQ(selector, value) {
    $(selector).each(function () {
      this.style.setProperty('display', value, 'important');
    });
  }

  if ($('.priceopt_member').hasClass('selected')) {
    setDisplayImportantJQ('.addto_normalbtn', 'block');
    setDisplayImportantJQ('.addtocart_popupbtn', 'none');
    setDisplayImportantJQ('.proceed-to-checkout button.checkout-button', 'none');
  } else {
    setDisplayImportantJQ('.addto_normalbtn', 'none');
    setDisplayImportantJQ('.addtocart_popupbtn', 'block');
    setDisplayImportantJQ('.proceed-to-checkout button.checkout-button', 'block');
  }
}

// Call once on page load
toggleButtons();

// Keep checking every 300ms to reflect changes when variant changes
setInterval(toggleButtons, 300);

// Update active class on radio button click
$(document).on('click', '.membership-radio-card', function () {
  $('.membership-radio-card').removeClass('active');
  $(this).addClass('active');
  $(this).find('input[type="radio"]').prop('checked', true);
  toggleButtons();
});

/////////////////////////////////
// Membership Add to Cart logic
